import { PBCC_PREMIUM } from './siteMode.js'

// ── TV-ONLY theme ─────────────────────────────────────────────────────────
// TEST/premium: deep pine #0E281D board + cream #F7F2E6 cards, matching the rest
// of the premium admin. Club/live keep the original TV-tuned values below.
// Dark-green background for the /tv display boards (the screens shown on the
// clubhouse TVs), DECOUPLED from the app/browser green (#123D26, CLUB.primary-
// Color) so it can be tuned for how it actually looks on a real TV without
// touching the app anywhere else.
//
// TVs oversaturate and lift dark colors, so this first guess is a touch DARKER
// and slightly LESS SATURATED than the app green (#123D26 → #0A2014: the green
// channel pulled toward the red/blue, and the whole value dimmed).
//
// ⚑ THIS IS THE ONE KNOB — change this single value and redeploy to dial it in.
// Deep forest of the LOGO's hue (#123D26) — dark enough for white-card contrast
// on the TV, but green (not near-black) so it's consistent with the pine-tree
// logo/palette. Previous near-black was #050F0A.
// TEST reads a CSS var so the full-screen TV routes ("TV Mode") can go a touch
// DARKER (#081E12) for washed-out TV panels WITHOUT changing the embedded admin
// monitor tiles (which don't carry the .pbcc-tv-mode class → keep #0E281D). The
// fallback keeps the color correct anywhere the var isn't defined. Club unchanged.
export const TV_BG_GREEN = PBCC_PREMIUM ? 'var(--tv-bg-green, #0E281D)' : '#123D26'

// Flight-panel green — the boxes that hold each flight's bracket on the TV
// Flight Brackets board. Its own TV-tuned knob: noticeably darker than the old
// panel green (#0E3320) but kept a touch LIGHTER than the near-black board
// border (TV_BG_GREEN) so the panels still read as panels. Full-screen TV
// brackets ONLY — the admin Bracket tab / browser keep the original #0E3320.
// ⚑ Change this ONE value and redeploy to dial it against the TV.
// Flight-panel green — a forest shade of the logo hue, a touch lighter than the
// board (TV_BG_GREEN) so panels read as panels. Previous: #06130B.
export const TV_PANEL_GREEN = '#123D26'

// TV-only card/box fill — turn the cream cards/boxes WHITE on the TV boards.
// Each TV board component imports this DIRECTLY (no color is ever passed as a
// prop, so nothing can be "not defined"). Full-screen TV only; the app, browser
// /leaderboard, and normal admin Bracket tab keep cream (#FFFFFF).
// ⚑ Change this ONE value back to '#FFFFFF' to restore cream instantly.
export const TV_CARD_WHITE = PBCC_PREMIUM ? '#F7F2E6' : '#FFFFFF'

// Text color on the white TV cards/boxes — PURE BLACK. Dark green (#123D26)
// read as LIGHT green on the Hisense (Vidaa) TV, which lifts dark colors; black
// can't be lifted, so it stays crisp on the Hisense and clean on the TCL.
// Applied to ALL text on those cards (team names, W/L labels, day headers,
// scores). Imported directly by each TV board component (no prop threading).
export const TV_CARD_TEXT = '#000000'
